theme.footerSection = (function () {
  function footer() {

    // 1. Make everything active by default
    document.querySelectorAll('.footer__widget').forEach(function (item) {
      item.classList.add('active');
      const inner = item.querySelector('.footer__widget_inner');
      if (inner) inner.style.display = 'block';
    });

    // 2. Disable all toggle clicks
    document.querySelectorAll(".footer__widget_toggle").forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();   // stop clicking
        e.stopPropagation();  // stop toggle event
      });
    });

    // 3. On resize keep everything open
    window.addEventListener('resize', function () {
      document.querySelectorAll('.footer__widget').forEach(function (item) {
        item.classList.add('active');
        const inner = item.querySelector('.footer__widget_inner');
        if (inner) inner.style.display = 'block';
      });
    });
  }

  return footer;
})();
